import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { createErrorApiResponse } from "@entrilia/shared/api/axiosHelper";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import FullScreenLoader from "@entrilia/shared/components/fullScreenLoader/FullScreenLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import biApi from "../../../../../api/biApi";
import useClientContext from "../../../../../context/useClientContext";
import { getEditUiReportUrl } from "../../report-lists/reports/utilities/editReportUrl";

const CreateDraftFromConfigurationPage = () => {
  const { configurationId } = useParams<{ configurationId: string }>();
  const { clientCode } = useClientContext();
  const navigate = useNavigate();

  const createDraftReport = useCallback(
    async (signal?: AbortSignal) => {
      if (!configurationId) {
        return createErrorApiResponse<string>({ message: "Configuration ID is missing" });
      }
      return await biApi.uiReports.createDraftReportFromBiAgentConfiguration(configurationId, signal);
    },
    [configurationId]
  );

  const [reportId, reportIdError] = useFetch(createDraftReport);

  useEffect(() => {
    if (reportId) {
      navigate(getEditUiReportUrl(clientCode, reportId), { replace: true });
    }
  }, [reportId, clientCode, navigate]);

  if (reportIdError) {
    return <DataLoadingFailed title="Failed to load the report" text={reportIdError.message} />;
  }

  return <FullScreenLoader title="Preparing report..." subtitle="Please wait while we prepare report data" />;
};

export default CreateDraftFromConfigurationPage;
